import { render, staticRenderFns } from "./VInvoicePlan.vue?vue&type=template&id=5913e254&"
import script from "./VInvoicePlan.vue?vue&type=script&lang=js&"
export * from "./VInvoicePlan.vue?vue&type=script&lang=js&"
import style0 from "./VInvoicePlan.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports